export const PLACE_INVITATION_ADDED = 0
export const PLACE_INVITATION_INVITED = 1
export const PLACE_INVITATION_PENDING_REQUEST = 2
export const PLACE_INVITATION_ACCEPT_REQUEST = 3
export const PLACE_INVITATION_ACCEPT_INVITATION = 4
export const PLACE_INVITATION_PUBLIC_SUBSCRIBE = 5
export const PLACE_INVITATION_DECLINED = 6
export const PLACE_INVITATION_IGNORED = 7
export const PLACE_INVITATION_REMOVE_SUBSCRIPTION = 8
export const PLACE_INVITATION_UNSUBSCRIBED = 9
export const PLACE_INVITATION_UNVERIFIED = 11
export const PLACE_DECLINED_BY_USER = 12
export const PLACE_SUBSCRIBED = [
  PLACE_INVITATION_ACCEPT_REQUEST,
  PLACE_INVITATION_ACCEPT_INVITATION,
  PLACE_INVITATION_PUBLIC_SUBSCRIBE,
]

export const PLACE_INVITATIONS = {
  [PLACE_INVITATION_ADDED]: 'subscriber.status.added',
  [PLACE_INVITATION_INVITED]: 'subscriber.status.invited',
  [PLACE_INVITATION_PENDING_REQUEST]: 'subscriber.status.pending',
  [PLACE_INVITATION_ACCEPT_REQUEST]: 'subscriber.status.subscribed',
  [PLACE_INVITATION_ACCEPT_INVITATION]: 'subscriber.status.subscribed',
  [PLACE_INVITATION_PUBLIC_SUBSCRIBE]: 'subscriber.status.subscribed',
  [PLACE_INVITATION_DECLINED]: 'subscriber.status.rejected',
  [PLACE_INVITATION_IGNORED]: 'subscriber.status.rejected_byAppUser',
  [PLACE_INVITATION_REMOVE_SUBSCRIPTION]: 'subscriber.status.unsubscribed',
  [PLACE_INVITATION_UNSUBSCRIBED]: 'subscriber.status.unsubscribed',
  [PLACE_INVITATION_UNVERIFIED]: 'subscriber.status.unverified',
  [PLACE_DECLINED_BY_USER]: 'subscriber.status.declineByUser',
}
